import React from 'react';
import { colors, rgbaFromHex } from '@/utils/colorSystem';

export default function TemplateIllustration({ type, color = colors.primary[400] }) {
    const bg = rgbaFromHex(color, 0.1);
    if (type === 'standard') {
        return (
            <svg viewBox="0 0 80 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="80" height="64" fill={bg}/>
                <rect x="8" y="8" width="64" height="6" rx="2" fill={color} fillOpacity="0.3"/>
                <rect x="8" y="22" width="20" height="34" rx="3" fill={color} fillOpacity="0.2"/>
                <rect x="34" y="22" width="38" height="14" rx="3" fill={color} fillOpacity="0.1"/>
                <rect x="34" y="42" width="38" height="14" rx="3" fill={color} fillOpacity="0.1"/>
            </svg>
        );
    }
    if (type === 'agile') {
        return (
            <svg viewBox="0 0 80 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="80" height="64" fill={bg}/>
                <rect x="10" y="10" width="16" height="44" rx="2" fill={color} fillOpacity="0.2"/>
                <rect x="32" y="10" width="16" height="44" rx="2" fill={color} fillOpacity="0.2"/>
                <rect x="54" y="10" width="16" height="44" rx="2" fill={color} fillOpacity="0.2"/>
                <rect x="13" y="14" width="10" height="6" rx="1" fill={color} fillOpacity="0.4"/>
                <rect x="35" y="24" width="10" height="6" rx="1" fill={color} fillOpacity="0.4"/>
                <rect x="57" y="18" width="10" height="6" rx="1" fill={color} fillOpacity="0.4"/>
            </svg>
        );
    }
    return (
        <svg viewBox="0 0 80 64" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="80" height="64" fill={bg}/>
            <path d="M12 48L24 32L36 40L52 20L68 36" stroke={color} strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
            <circle cx="52" cy="20" r="4" fill={color}/>
        </svg>
    );
}
